import React from "react";
import { matchPath, useHistory, useLocation } from "react-router-dom";
import { useAuthentication } from "../../../context/authentication";
import { DottedMenu } from "../../../context/dropdownMenu/DropdownMenuProvider";
import { useInstalls } from "../../../context/installs";
import { useToast } from "../../../context/toast";
import { Install } from "../../../utils/types";

interface Props {
  disabled?: boolean;
  install: Install;
  toggleEditInstallForm: (install: Install) => void;
}

const InstallActionsButton: React.FC<Props> = ({
  disabled,
  install,
  toggleEditInstallForm
}) => {
  const { setModalWarningConfig } = useToast();
  const { wrapActionWithAuth } = useAuthentication();
  const { removeInstall } = useInstalls();
  const browserLocation = useLocation();
  const history = useHistory();

  // TODO: ensure that this is right
  const detailsPageMatch = matchPath<{
    id: string;
    section: string;
  }>(browserLocation.pathname, {
    path: "/installs/:id/:section"
  });

  return (
    <DottedMenu
      disabled={disabled}
      menuItems={[
        {
          onClick: wrapActionWithAuth(() => {
            toggleEditInstallForm(install);
          }),
          text: "Edit install"
        },
        {
          onClick: wrapActionWithAuth(() => {
            setModalWarningConfig({
              open: true,
              resolve: () => {
                removeInstall(install.uuid);

                if (detailsPageMatch?.params?.id === install.uuid) {
                  history.push("/installs");
                }
              }
            });
          }),
          text: "Remove install"
        }
      ]}
      text="Open install actions"
    />
  );
};

export default InstallActionsButton;
